/* eslint-disable indent */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { getOtherUserAction } from "../../../../redux/actions/profileActions";
import { logProfileVisits } from "../../../../redux/actions/insightActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import { bool, func, object, string } from "prop-types";
import { Divider, IconButton } from "@material-ui/core";
import icons from "../../../../assets/icons/icon-collection.svg";
import CustomButton from "../../../../components/CustomButton";
import ViewDetails from "./ViewDetails";
import Refer from "./ReferJob";
import moment from "moment";

import Apply from "./Apply";
import PostApplicationReferralModal from "./PostApplicationReferralModal";
import { useDispatch, useSelector } from "react-redux";
import {
  applyAction,
  // getJob,
  saveJobAction,
  applyToRecruiterJob,
  getEitherJob,
  recruitRequest,
} from "../../../../redux/actions/jobActions";
import { resetJob } from "../../../../redux/actions/businessActions";
import { ButtonLoader } from "../../../../components/ButtonLoader";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { SectionLoader } from "../../../../components/PageLoader";
import { updateProfileAction } from "../../../../redux/actions/profileActions";
import { saveBusinessRef } from "../../../../redux/actions/businessActions";
import { demoAction } from "../../../../redux/actions/demoActions";
import cogoToast from "cogo-toast";
import { getMatchScore } from "../../../../services/matchScoreService";
import { shouldSuppressTestUnavailableFeedback } from "../../../../utils/testEnvironment";
import { trackJobView } from "../../../../utils/analytics";


const HomeModal = ({ open, handleClose, hideActions, isBusiness }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();
  const [clickedButton, setClickedButton] = useState("jobDescription");
  const { id } = useParams();
  const { jobId, recruiterId, company_id, refLink } = useParams();
  const [loading, setLoading] = useState(false);
  const [section, setSection] = useState();

  const [subSection, setSubSection] = useState("details");
  const [applying, setApplying] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [pendingPhone, setPendingPhone] = useState("");
  const [pendingFullName, setPendingFullName] = useState("");
  const [hasUploadedResume, setHasUploadedResume] = useState(false);

  // Match score state
  const [matchScore, setMatchScore] = useState(null);
  const [matchRecommendation, setMatchRecommendation] = useState("");
  const [matchLoading, setMatchLoading] = useState(false);
  const [matchError, setMatchError] = useState(null);

  const { userData } = useSelector(({ auth }) => auth);
  const { resume } = useSelector(({ profile }) => profile);
  const path = history.location.pathname;
  const { job } = useSelector((state) => state.job);

  const requestToRecruit = async () => {
    recruitRequest(jobId);
  };

  useEffect(() => {
    if (id) {
      getOtherUserAction(dispatch, id);
      logProfileVisits(id);
    }
  }, [dispatch, id]);

  const refCode = userData.refCode;
  useEffect(() => {
    // Clear stale job data immediately so the previous job
    // doesn't flash before the new one loads.
    resetJob(dispatch);
    setLoading(true);
    Promise.resolve(
      getEitherJob(
        dispatch,
        jobId,
        path.includes("recommended") ? true : isBusiness,
      ),
    ).finally(() => {
      setLoading(false);
    });
  }, [dispatch, jobId]);

  // Track job view whenever the modal opens for a valid job
  useEffect(() => {
    if (jobId && job?.id) {
      trackJobView(job.id, job.role_title, job.company_name);
    }
  }, [job?.id, jobId]);

  useEffect(() => {
    if (pathname.includes("apply") || pathname.includes("recommended")) {
      setSection("apply");
      setPendingPhone(userData?.phone || "");
    } else if (pathname.includes("refer")) {
      setSection("refer");
    } else {
      setSection("details");
    }
  }, [pathname]);

  // Handle manual match score calculation
  const handleCalculateMatch = async () => {
    // Only fetch for non-business users, when job data is available, and when in apply section
    if (
      !job ||
      !userData ||
      isBusiness ||
      section !== "apply" ||
      localStorage.getItem("accountType") === "business"
    ) {
      return;
    }

    setMatchLoading(true);
    setMatchError(null);

    try {
      const result = await getMatchScore(job.id, userData.id);

      if (result.success) {
        setMatchScore(result.matchScore);
        setMatchRecommendation(result.recommendation);
      } else if (!shouldSuppressTestUnavailableFeedback(result)) {
        setMatchError(result.error);
      }
    } catch (error) {
      console.error("Error fetching match score:", error);
      setMatchError("Failed to fetch match score");
    } finally {
      setMatchLoading(false);
    }
  };

  const saveJob = (jobId) => {
    saveJobAction(dispatch, jobId);
  };
  const viewJobDetails = () => {
    history.push(`/home/${jobId}`);
    setSection("details");
    setSubSection("details");
    setClickedButton("jobDescription");
  };

  const saveForLater = () => {
    const payload = {
      job_id: jobId,
      status: 1,
      refCode,
    };
    const saveLater = async () => {
      await saveBusinessRef(dispatch, 1, payload);
    };
    if (localStorage.getItem("accountType") === "business") {
      saveJob(jobId);
    } else {
      saveLater();
    }
  };
  const viewDocument = () => {
    history.push(`/home/${jobId}`);
    setSection("details");
    setSubSection("documents");
    setClickedButton("additionalDocuments");
  };
  const applyToJob = () => {
    // if (
    //   !profileData?.first_name ||
    //   !profileData?.about ||
    //   !profileData?.resume ||
    //   !profileData?.last_name ||
    //   !profileData?.gender ||
    //   !profileData?.dob ||
    //   !profileData.country ||
    //   !profileData.location ||
    //   !profileData.experience
    // ) {
    //   cogoToast.error("Please complete your profile");
    //   return;
    // }
    setApplying(true);
    const refCode = refLink ? refLink : null;
    const recruitId = recruiterId ? recruiterId : null;
    const resumeLink =
      resume && resume.link && resume.name
        ? { resume: resume.link, resumeName: resume.name }
        : null;
    // Derive first and last name, allowing user-entered pending full name
    const hasStoredNames = userData.first_name && userData.last_name;
    const trimmedFull = (pendingFullName || "").trim();
    const nameParts = trimmedFull.split(" ").filter(Boolean);
    const derivedFirst = hasStoredNames
      ? userData.first_name
      : nameParts[0] || userData.first_name || "";
    const derivedLast = hasStoredNames
      ? userData.last_name
      : nameParts.slice(1).join(" ") || userData.last_name || "";
    const isroute = isBusiness
      ? "/referrals/insights"
      : "/insights/applications";
    const onApplySuccess = () => {
      if (!isBusiness) {
        setShowReferralModal(true);
      } else {
        history.push(isroute);
      }
    };
    // if (resume && resume.link && resume.userId === userData.id) {
    if (resumeLink && userData.id) {
      const data = {
        about: userData.about,
        country: userData.country,
        dob: userData.dob,
        first_name: derivedFirst,
        gender: userData.gender,
        image_url: userData.image_url,
        industry: userData.industry,
        isShowOnProfile: userData.isShowOnProfile,
        last_name: derivedLast,
        links: userData.links,
        phone: userData.phone || pendingPhone,
        resume: resumeLink.resume,
        resumeName: resumeLink.resumeName,
        state: userData.state,
      };
      Promise.all([
        updateProfileAction(data, dispatch),
        recruitId && recruitId.length < 5
          ? applyToRecruiterJob(dispatch, job.id, recruitId, onApplySuccess)
          : applyAction(
              dispatch,
              job.id,
              refCode,
              company_id || job.company_id,
              onApplySuccess,
            ),
        cogoToast.success(),
      ]).finally(() => {
        setApplying(false);

        // history.push("/home/");
      });
    } else {
      Promise.resolve(
        recruitId && recruitId.length < 5
          ? applyToRecruiterJob(dispatch, job.id, recruitId, onApplySuccess)
          : applyAction(
              dispatch,
              job.id,
              refCode,
              company_id || job.company_id,
              onApplySuccess,
            ),
      ).finally(() => {
        setApplying(false);

        // history.push("/home/");
      });
    }
  };

  return (
    <div className="position-relative">
      <PostApplicationReferralModal
        open={showReferralModal}
        onClose={() => setShowReferralModal(false)}
        excludeJobId={job?.id}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="View details"
        PaperProps={{
          style: {
            width: "95%",
            maxWidth: "50rem",
            borderRadius: "1rem",
            padding: "0.75rem",
          },
        }}
      >
        {!job && loading && (
          <div className="min-height-25">
            <SectionLoader />
          </div>
        )}

        {job && !loading && (
          <>
            <div className="d-flex justify-content-between align-items-centter">
              <DialogTitle id="details-dialog-title">
                <div>
                  <h2 className="job-title mb-0">{job.role_title}</h2>

                  <p className="mb-0 co-darkgray">{job.campany_name}</p>
                </div>
              </DialogTitle>
              <div className="close-button">
                <IconButton onClick={handleClose}>
                  <svg width="30" height="30" className="rounded-circle">
                    <use href={`${icons}#close`}></use>
                  </svg>
                </IconButton>
              </div>
            </div>
            <div className="position-relative sticky">
              <div>
                {(section === "details" || section === "refer") && (
                  <div className="d-flex px-4 justify-content-start">
                    <button
                      onClick={viewJobDetails}
                      className={`co-white mr-2 px-4 py-2 fw-bold border-0 rounded ${
                        clickedButton === "jobDescription"
                          ? "bg-dark"
                          : "bg-primary"
                      }`}
                    >
                      Job Description
                    </button>
                    <button
                      onClick={viewDocument}
                      className={`co-white px-4 py-2 fw-bold border-0 rounded ${
                        clickedButton === "additionalDocuments"
                          ? "bg-dark"
                          : "bg-primary"
                      }`}
                    >
                      Additional Documents
                    </button>
                  </div>
                )}

                {section === "apply" && (
                  <div className="d-flex px-4 justify-content-start">
                    <button
                      onClick={viewJobDetails}
                      className="co-white px-4 py-2 fw-bold border-0 rounded bg-primary"
                    >
                      Applicant&apos;s Details
                    </button>
                  </div>
                )}

                <div className="d-flex justify-content-start my-3">
                  <span className="ml-4 mr-2 co-gray d-block">
                    posted {moment(job.date_created).fromNow()}
                  </span>
                </div>

                <div className="d-flex justify-content-start my-3">
                  <span className="ml-4 mr-2">
                    <svg width="17" height="16" className="mr-1">
                      <use href={`${icons}#briefcase`}></use>
                    </svg>
                    {job.job_level && job.job_level.title}
                  </span>
                  <span className="mr-2">
                    <svg width="14" height="14" className="mr-1">
                      <use href={`${icons}#mappin`}></use>
                    </svg>
                    {job.location}
                  </span>
                  <span className="mr-2">
                    <svg width="24" height="17" className="mr-1">
                      <use href={`${icons}#persons`}></use>
                    </svg>
                    {job.no_of_staff} workers
                  </span>
                </div>
                <Divider />
              </div>
            </div>

            <DialogContent>
              <div className="mt-3">
                {section === "details" && (
                  <ViewDetails
                    job={job}
                    section={subSection}
                  />
                )}
                {section === "refer" && (
                  <Refer job={job} isBusiness={isBusiness} />
                )}
                {section === "apply" && (
                  <Apply
                    pendingPhone={pendingPhone}
                    setPendingPhone={setPendingPhone}
                    pendingFullName={pendingFullName}
                    setPendingFullName={setPendingFullName}
                    setHasUploadedResume={setHasUploadedResume}
                    matchScore={matchScore}
                    matchRecommendation={matchRecommendation}
                    matchLoading={matchLoading}
                    matchError={matchError}
                    onCalculateMatch={handleCalculateMatch}
                  />
                )}
              </div>

              {job.isSaved == 0 && (
                <div className="d-flex justify-content-end my-1">
                  <div className="w-50 d-flex align-items-center justify-content-end">
                    <span className="co-green mr-1">
                      <b>Save for later</b>
                    </span>
                    <button
                      type="button"
                      onClick={() => saveJob(job.id)}
                      className="borderless bg-white"
                    >
                      <svg width="42" height="42" className="mr-1">
                        <use href={`${icons}#save`}></use>
                      </svg>
                    </button>
                  </div>
                </div>
              )}
              {job.isSaved == 1 && (
                <div className="d-flex justify-content-end my-1">
                  <div className="w-50 d-flex align-items-center justify-content-end">
                    <span className="co-green mr-1">
                      <b>Saved</b>
                    </span>
                  </div>
                </div>
              )}
            </DialogContent>
            {!hideActions && (
              <DialogActions>
                {section === "details" && (
                  <>
                    {job?.job_tier !== 1 && job?.job_tier !== '1' && (
                      <CustomButton
                        backgroundColor="#41B883"
                        handleClick={() => history.push(`/home/${jobId}/refer`)}
                        color="#fff"
                        text="Refer"
                        additionalClass="mx-3 mt-2"
                      />
                    )}

                    {!isBusiness && (
                      <CustomButton
                        handleClick={() => {
                          history.push(`/home/${jobId}/apply`);
                          const state = {
                            ["See more details of job here"]: false,
                            ["Apply here"]: false,
                          };
                          demoAction(dispatch, state);
                        }}
                        backgroundColor="#3A6ED4"
                        color="#fff"
                        disabled={applying || job?.is_applied}
                        text={job?.is_applied ? "Applied" : "Apply"}
                        additionalClass="mx-3 mt-2"
                      />
                    )}
                  </>
                )}
                {section === "apply" && (
                  <div
                    className="d-flex flex-column w-100 text-center"
                    style={{ padding: "8px 14px" }}
                  >
                    {(!(userData.first_name || pendingFullName) ||
                      !(userData.phone || pendingPhone) ||
                      !(userData.resume || resume || hasUploadedResume)) && (
                      <div style={{ color: "red" }}>
                        {" "}
                        <span>
                          <Link to="/profile">
                            Complete your profile before you can apply
                          </Link>
                        </span>
                      </div>
                    )}

                    {section === "apply" && (
                      <CustomButton
                        handleClick={(event) => {
                          event.preventDefault();
                          applyToJob();
                        }}
                        backgroundColor="#3A6ED4"
                        color="#fff"
                        text={applying ? <ButtonLoader /> : <span>Apply</span>}
                        additionalClass="mt-2"
                        disabled={
                          applying ||
                          !(userData.first_name || pendingFullName) ||
                          !(userData.phone || pendingPhone) ||
                          !(userData.resume || resume || hasUploadedResume)
                        }
                      />
                    )}
                  </div>
                )}
                {isBusiness && (
                  <CustomButton
                    backgroundColor="#41B883"
                    handleClick={saveForLater}
                    color="#fff"
                    text="Save for Later"
                    additionalClass="mx-3 mt-2"
                    loading={loading}
                  />
                )}

                {userData.isRecruiter === 1 &&
                  job.canRecruiterRequest === "1" && (
                    <CustomButton
                      backgroundColor="#41B883"
                      handleClick={requestToRecruit}
                      color="#fff"
                      text="Request to Recruit"
                      additionalClass="mx-3 mt-2"
                      loading={loading}
                    />
                  )}
              </DialogActions>
            )}
          </>
        )}
      </Dialog>
    </div>
  );
};

HomeModal.propTypes = {
  success: bool,
  setSuccess: func,
  open: bool.isRequired,
  handleClose: func.isRequired,
  section: string.isRequired,
  setSection: func.isRequired,
  job: object,
  hideActions: bool,
};

HomeModal.defaultProps = {
  job: {},
  success: false,
  setSuccess: () => {},
  hideActions: false,
};

export default HomeModal;
